import { type Entry } from '@clubspark-node/clubspark-tennis-types';
import { entryStatusConstants, tournamentEngine } from 'tods-competition-factory';

import { ROUND_ROBIN_GROUP_SIZE_LIMIT } from 'constants/draws';

export const getSeedsCount = (drawSize: number, entries: Entry[], policyDefinitions: any) => {
  let participantsCount =
    entries?.filter((entry) => entryStatusConstants.DIRECT_ENTRY_STATUSES.includes(entry.entryStatus)).length ||
    drawSize;

  if (participantsCount > drawSize) participantsCount = drawSize || 0;

  const { seedsCount }: { seedsCount: number } = tournamentEngine.getSeedsCount({
    participantsCount,
    policyDefinitions,
    drawSize,
  });
  return seedsCount || 0;
};

export const getGroupSizeOptions = (drawSize) => {
  const { validGroupSizes } = tournamentEngine.getValidGroupSizes({
    groupSizeLimit: ROUND_ROBIN_GROUP_SIZE_LIMIT,
    drawSize,
  });
  return validGroupSizes.map((o) => ({ text: o, value: o }));
};

export const calcEliminationDrawSize = (participantsCount: number) =>
  [0, 2, 4, 8, 16, 32, 64, 128, 256].find((drawSize) => drawSize >= participantsCount) || 0;
